import './Blocks/style.scss';


console.log(`[cnti-plugin] Front module loaded`)
